import { Heart, Instagram, Mail, MapPin, Phone, Sparkles } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Track navigation click in GA
      if (window.gtag) {
        window.gtag('event', 'navigation_click', {
          'destination_section': sectionId,
          'method': 'footer_link'
        });
      }
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="w-6 h-6 text-rose-400" />
              <h3 className="text-xl font-serif font-bold">Makeup By Khushi</h3>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-4">
              Your trusted makeup artist for weddings, parties, and special occasions. 
              Enhancing natural beauty with professional artistry.
            </p>
            <div className="flex items-center space-x-3">
              <a 
                href="https://www.instagram.com/khushi.mua/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-stone-800 p-2 rounded-full hover:bg-rose-500 transition-colors"
                onClick={() => {
                  if (window.gtag) {
                    window.gtag('event', 'social_click', {
                      'platform': 'Instagram',
                      'location': 'Footer'
                    });
                  }
                }}
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  About Me
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('packages')} className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  Packages
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-stone-400">
              <li>Bridal Makeup</li>
              <li>Bridesmaids Makeup</li>
              <li>Baby Shower Makeup</li>
              <li>Photoshoot Makeup</li>
              <li>Pre-Bridal Services</li>
              <li>Floral Jewellery</li>
              <li>Bridal Outfit Styling</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-rose-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+919099302024" className="text-stone-400 hover:text-rose-400 transition-colors text-sm">
                  +91 90993 02024
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-rose-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:khushalipadiya26@gmail.com" className="text-stone-400 hover:text-rose-400 transition-colors text-sm break-all">
                  khushalipadiya26@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-rose-400 mt-0.5 flex-shrink-0" />
                <span className="text-stone-400 text-sm">
                  Pune, Hinjewadi 411057<br />
                  <span className="text-rose-400 text-xs">Travel worldwide</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-stone-400 text-sm">
              © {new Date().getFullYear()} Makeup By Khushi. All rights reserved.
            </p>
            <div className="flex items-center space-x-2 text-stone-400 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-rose-400 fill-rose-400" />
              <span>for beautiful brides</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;